import React, { useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { Form } from "antd";

import {
  loadCurrencies,
  loadMaxConsignmentPrices,
} from "../../../../modules/staticDataLoad";
import SelectItemWithLoad from "../selectItemWithLoad";
import NumberWithCurrency from "../numberWithCurrency";

export const defaultMaxInsuranceInCzk = 1000000,
  defaultLimitInCzk = 500000;

function ConsignmentPriceItem({
  error,
  product,
  onMaxSet,
  optional,
  disabled,
  skeleton,
  thirdItem,
  currencies,
  labelValue,
  onLimitSet,
  noMaxValue,
  inlineLabel,
  formItemLayout,
  initialServices,
  emptyCurrencies,
  amountFieldName,
  currencyClassName,
  currencyFieldName,
  getFieldDecorator,
  disableCurrencySet,
  onConsignmentPriceChange,
  deliveryCountryCurrencies,
  onConsignmentPriceCurrencyChange,
}) {
  const intl = useIntl();

  const [allCurrencies, setAllCurrencies] = useState();
  useEffect(
    () => emptyCurrencies && loadCurrencies(setAllCurrencies),
    [emptyCurrencies]
  );

  const [consignmentPriceCurrency, setConsignmentPriceCurrency] = useState(
    initialServices && initialServices.consignmentPriceCurrency
  );
  const handleCurrencyChange = useCallback(
    (currency) => {
      onConsignmentPriceCurrencyChange &&
        onConsignmentPriceCurrencyChange(currency);
      setConsignmentPriceCurrency(currency);
    },
    [onConsignmentPriceCurrencyChange]
  );

  const [currenciesForPrice, setCurrenciesForPrice] = useState();
  useEffect(
    () =>
      deliveryCountryCurrencies &&
      deliveryCountryCurrencies !== "e" &&
      deliveryCountryCurrencies.some((c) => c.forConsignmentPrice)
        ? setCurrenciesForPrice(
            deliveryCountryCurrencies.filter((c) => c.forConsignmentPrice)
          )
        : (currencies || allCurrencies) &&
          (currencies || allCurrencies).filter &&
          setCurrenciesForPrice(
            (currencies || allCurrencies).filter((c) => c.forConsignmentPrice)
          ),
    [currencies, allCurrencies, deliveryCountryCurrencies]
  );
  useEffect(() => {
    currenciesForPrice &&
      !consignmentPriceCurrency &&
      handleCurrencyChange(currenciesForPrice[0]);
  }, [currenciesForPrice, handleCurrencyChange, consignmentPriceCurrency]);

  const [maxConsignmentPrices, setMaxConsignmentPrices] = useState();
  useEffect(
    () =>
      loadMaxConsignmentPrices(product && product.id, setMaxConsignmentPrices),
    [product]
  );

  const [maxConsignmentPrice, setMaxConsignmentPrice] = useState(
    defaultMaxInsuranceInCzk
  );
  useEffect(() => {
    if (
      maxConsignmentPrices &&
      maxConsignmentPrices !== "e" &&
      consignmentPriceCurrency
    ) {
      const max = maxConsignmentPrices.find(
        (m) => m.currency.id === consignmentPriceCurrency.id
      );
      onLimitSet && onLimitSet((max && max.limitValue) || defaultLimitInCzk);
      const maxPrice = (max && max.maxValue) || defaultMaxInsuranceInCzk;
      onMaxSet && onMaxSet(maxPrice);
      setMaxConsignmentPrice(maxPrice);
    }
  }, [onMaxSet, onLimitSet, maxConsignmentPrices, consignmentPriceCurrency]);

  const form = (
    <NumberWithCurrency
      error={error}
      precision={2}
      disabled={disabled}
      thirdItem={thirdItem}
      currencies={currenciesForPrice}
      label={inlineLabel && labelValue}
      amountSpan={inlineLabel ? 13 : 9}
      amountOffset={inlineLabel ? 0 : 3}
      currencySpan={inlineLabel ? 7 : 12}
      message={
        optional
          ? undefined
          : intl.formatMessage({
              id: "consignment.services.emptyPrice",
              defaultMessage: "Zadejte hodnotu!",
            })
      }
      formItemLayout={formItemLayout}
      onSetCurrency={handleCurrencyChange}
      currencyClassName={currencyClassName}
      getFieldDecorator={getFieldDecorator}
      disableCurrencySet={disableCurrencySet}
      onInputChange={onConsignmentPriceChange}
      amountFieldName={amountFieldName || "consignmentPrice"}
      maxAmount={noMaxValue ? 999999999 : maxConsignmentPrice}
      currencyFieldName={currencyFieldName || "consignmentPriceCurrencyId"}
      initialAmount={initialServices && initialServices.consignmentPrice}
      initialCurrency={
        initialServices && initialServices.consignmentPriceCurrencyId
      }
    />
  );

  return (
    <SelectItemWithLoad skeleton={skeleton} options={currenciesForPrice}>
      {inlineLabel ? form : <Form.Item label={labelValue}>{form}</Form.Item>}
    </SelectItemWithLoad>
  );
}

export default ConsignmentPriceItem;
